const navs = [
    {
        title: '公司治理',
        path: 'company'
    },
    {
        title: '公司公告',
        path: 'notices'
    },
    {
        title: '定期报告',
        path: 'financial-report',
        children: [
            {
                title: '财务报告',
                path: 'financial'
            },
            {
                title: '社会责任报告',
                path: 'duty'
            }
        ]
    },
    {
        title: '投资者联络',
        path: 'contact'
    },
    {
        title: '投资者关系日历',
        path: 'board-of-director',
        children: [
            {
                title: '董事会',
                path: 'director'
            },
            {
                title: '股东会',
                path: 'shareholder'
            },

            {
                title: '投资者活动日',
                path: 'activity'
            }
        ]
    }
]

const listTitle = {
    getCompanyAnnouncement: '公司公告',
    getFinancialReport: '财务报告',
    getSocialResponsibilityReports: '社会责任报告',
    getBoardOfDirector: '董事会',
    getBoardOfShareholder: '股东会',
    getInvestorDays: '投资者活动日'
}

export { navs, listTitle }



// WEBPACK FOOTER //
// ./src/pages/investorRelations/config.js